import { render, staticRenderFns } from "./siPurchaseOrders.vue?vue&type=template&id=4304d474&scoped=true&"
import script from "./siPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./siPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./siPurchaseOrders.vue?vue&type=style&index=0&id=4304d474&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4304d474",
  null
  
)

component.options.__file = "siPurchaseOrders.vue"
export default component.exports